import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { identity } from '../../modules/tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../modules/tornado/utils/style';

const defaultContext = makeDefaultStylingContext();

export const WIDTH = {
  [HD]: 640,
  [FULL_HD]: 960,
};

export const PADDING = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const TITLE_PADDING = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const TEXT_PADDING_RIGHT = {
  [HD]: 48,
  [FULL_HD]: 72,
};

export const colors = {
  unfocused: makeThemeColor(TERTIARY),
  focused: makeThemeColor(PRIMARY, 0.3),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const width = WIDTH[screenSize];
  const wordWrapWidth = width - TEXT_PADDING_RIGHT[screenSize];
  const titleFont = getFont(FONT.BERLIN_3, screenSize);
  const descriptionFont = getFont(FONT.BERLIN_1, screenSize);

  return {
    w: width,
    color: colors.unfocused[colorMode],
    flex: { direction: 'row', padding: PADDING[screenSize], wrap: true },
    TextWrapper: {
      flex: { direction: 'column' },
      w: identity,
      Title: {
        text: {
          wordWrapWidth,
          wordWrap: true,
          ...titleFont,
        },
        paddingBottom: TITLE_PADDING[screenSize],
        wordWrap: true,
      },
      Description: {
        text: {
          wordWrapWidth,
          wordWrap: true,
          ...descriptionFont,
        },
      },
    },
    Checkbox: {
      mountX: 1,
      x: width - PADDING[screenSize],
    },
    Border: {
      borderWidthBottom: 1,
      colorBorder: colors.focused[colorMode],
      w: identity,
      mountY: 1,
      x: -PADDING[screenSize],
      y: PADDING[screenSize],
    },
  };
};

export const getFocusedStyle = (context = defaultContext) => {
  const { colorMode } = context;

  return {
    color: colors.focused[colorMode],
  };
};

export const getUnfocusedStyle = (context = defaultContext) => {
  const { colorMode } = context;

  return {
    color: colors.unfocused[colorMode],
  };
};
